import { render, staticRenderFns } from "./FollowupPagination.vue?vue&type=template&id=42a3d844&"
import script from "./FollowupPagination.vue?vue&type=script&lang=js&"
export * from "./FollowupPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports